import React from 'react'
import { Pressable, Text, View } from 'react-native'

import PhosphorIcon from '@ui-kit/components/PhosphorIcon'
import { COLOR } from '@ui-kit/constants'

import { itemActionRow } from './styles'
import type { ItemActionRowProps } from './types'

const ItemActionRow = (props: ItemActionRowProps) => {
  const styles = itemActionRow({ disabled: props.disabled })

  return (
    <View className={styles.container()}>
      <View className={styles.tile()}>
        <PhosphorIcon
          name={props.iconName}
          size={24}
          weight={props.iconWeight ?? 'bold'}
          color={COLOR.grey700}
        />
      </View>
      <View className={styles.textContainer()}>
        <Text className={styles.title()}>{props.title}</Text>
        {props.subtitle ? <Text className={styles.subtitle()}>{props.subtitle}</Text> : null}
      </View>
      <Pressable
        id={props.id}
        testID={props.id}
        role="button"
        aria-label={[props.actionLabel, props.title].filter(Boolean).join(' ')}
        aria-disabled={props.disabled}
        className={styles.action()}
        disabled={props.disabled}
        onPress={props.onPress}
      >
        <PhosphorIcon name={props.actionIconName} size={16} weight="fill" color={COLOR.black} />
        {props.actionLabel ? (
          <Text className={styles.actionLabel()}>{props.actionLabel}</Text>
        ) : null}
      </Pressable>
    </View>
  )
}

export default ItemActionRow
